import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export const getURLToDownloadReport = async (
  id: string,
  type: string,
  options?: AxiosRequestConfig,
) => {
  const {
    data: { url },
  } = await companiesApi.get<{ url: string }>(
    apiRoutes.getURLToDownloadReport(id, type),
    options,
  )

  return url
}
